module.exports = __webpack_public_path__ + "static/media/tachometer-alt-fastest.593dada1.svg";